import { Dialog, DialogContent } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import { useRef, useState } from 'react'

export default function PreviewImage({ status, toggleModal, image }) {
  const img = useRef('')
  const [height, setHeight] = useState(300)
  const [width, setWidth] = useState(300)
  let add = 50
  function zoomin() {
    setHeight((prevState) => prevState + add)
    setWidth((prevState) => prevState + add)
  }
  function zoomout() {
    setHeight((prevState) => prevState - add)
    setWidth((prevState) => prevState - add)
  }
  return (
    <>
      <Dialog
        open={status}
        onClose={toggleModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen
        className="preview-image-modal"
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle> */}
        <div className="preview-dialog-header">
          <ZoomInIcon onClick={() => zoomin()} />
          <ZoomOutIcon onClick={() => zoomout()} />
          <CloseIcon onClick={() => toggleModal(false)} />
        </div>
        <DialogContent className="primary-scroll">
          <div className="preview-image-main">
            {/* <div className="preview-image-inner"> */}
            <img src={image} className="" style={{ height: height, width: width }} ref={img} />
            {/* </div> */}
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
